// - fx/FXBuilder.js
import { FXEngine } from "./FXEngine";

export class FXBuilder {

    constructor() {

        this.items = [];

    }

    add(options) {

        this.items.push(options);

        return this;

    }

    run() {

        this.items.forEach(opts => new FXEngine(opts));

        return this;

    }

}